import { useDeferredValue } from 'react';
import { Box, BoxProps, Spinner, getVariant } from '@apia/theme';
import { useTabsContext } from './util';
import { observer } from 'mobx-react-lite';
import { Tab } from './tabsController';

const InnerRenderer = observer(({ tab }: { tab: Tab }) => {
  const state = tab.state;
  const Render = useDeferredValue(state.content);

  return (
    <Box
      aria-hidden={!state.isOpen}
      aria-labelledby={`tab-${tab.controller.id}-${state.id}`}
      className={`tabs__content ${state.isOpen ? 'open' : ''}`}
      data-id={state.id}
      id={`tabpanel-${tab.controller.id}-${state.id}`}
      key={state.id}
      role="tabpanel"
    >
      <Render tab={tab} />
      {state.isLoading && (
        <Box className="tabs__content__spinner__wrapper">
          <Spinner />
        </Box>
      )}
    </Box>
  );
});

export const TabsContent = observer((props: Omit<BoxProps, 'children'>) => {
  const controller = useTabsContext();

  if (!controller) return null;

  return (
    <Box
      className="tabs__content__wrapper"
      {...getVariant('layout.common.tabs.primary.content')}
      {...props}
    >
      {controller.tabsList.map((tab) => {
        return <InnerRenderer tab={tab} key={tab.id} />;
      })}
    </Box>
  );
});
